// export const exportToCSV = (data) => {
//     let csv = "Level,Name,Code\n";
//     data.forEach((row) => {
//         csv += `${row.level},${row.name},${row.code}\n`;
//     });

//     const blob = new Blob([csv], { type: "text/csv" });
//     const url = window.URL.createObjectURL(blob);

//     const a = document.createElement("a");
//     a.href = url;
//     a.download = "geographic_master_data.csv";
//     a.click();
// };

// utils/exportCSV.js

// Utility to capitalize each word
const capitalizeWords = (str) =>
    str.replace(/\b\w/g, (char) => char.toUpperCase());

export const exportToCSV = (data, filename = "master-data.csv") => {
    if (!data || data.length === 0) return;

    // Map data and capitalize names
    const formattedData = data.map((item) => ({
        ...item,
        name: capitalizeWords(item.name), // capitalize for export
    }));

    const headers = Object.keys(formattedData[0]).join(",");
    const rows = formattedData
        .map((row) => Object.values(row).join(","))
        .join("\n");

    const csvContent = `${headers}\n${rows}`;
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};